import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import PujaCheckoutModal from '../puja/PujaCheckoutModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PujaBookingForm = () => {
  const { templeId, pujaId } = useParams();
  const [searchParams] = useSearchParams();
  const requestedPkgId = searchParams.get('package');
  const navigate = useNavigate();

  const [temple, setTemple] = useState(null);
  const [puja, setPuja] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [templeRes, pujaRes] = await Promise.allSettled([
          axios.get(`${API}/temples/${templeId}`),
          axios.get(`${API}/pujas/${pujaId}`)
        ]);

        const pData = pujaRes.status === 'fulfilled' ? pujaRes.value.data : null;
        const tData = templeRes.status === 'fulfilled' ? templeRes.value.data : null;

        if (pData) {
          // Seamlessly redirect to single puja detail with checkout opened
          const targetUrl = `/puja/${pData.slug || pData.id}?book=true${requestedPkgId ? `&package=${requestedPkgId}` : ''}`;
          navigate(targetUrl, { replace: true });
          return;
        }

        setTemple(tData);
        setPuja(pData);
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Failed to load puja details');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [templeId, pujaId, requestedPkgId, navigate]);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-[#FBF4E7] pt-24 pb-16 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#6E1B34] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-sm font-semibold text-[#4E1225]">Opening Sacred Puja Checkout...</p>
        </div>
      </div>
      {puja && (
        <PujaCheckoutModal
          isOpen={true}
          onClose={() => navigate(`/puja/${puja.slug || puja.id}`)}
          puja={puja}
          selectedPackage={selectedPackage}
          temple={temple}
        />
      )}
      <Footer />
    </>
  );
};

export default PujaBookingForm;
